$(function () {
    let activeStep = $('.steps-and-actors').data('default-step');
    let activeActor = 'undefined';
    $('.steps-and-actors').on('click', '#diagram > g', function (e) { 
        e.preventDefault();
        if ($(this).data('step') === undefined) {
            return false;
        }

        activeStep = $(this).data('step');
        activeActor = 'undefined';
        updateStep();        
    });

    $('.steps-and-actors').on('click', '.actor-icons .icon', function (e) { 
        e.preventDefault();
        activeActor = $(this).data('actor');

        updateActor();
        
    });

    $('.steps-and-actors').on('click', '.step-content .close-actor', function (e) { 
        e.preventDefault();
        activeActor = 'undefined';

        updateActor();
        
    });

    $('.steps-and-actors').on('click', '.step-content .links a', function (e) { 
        e.preventDefault();
        activeActor = $(this).data('actor');

        updateActor();
        
    });

    const updateStep = () => {
        $('#diagram > g, .image-area img, .step-content, .actor-icons > div').removeClass('active');
        $('#diagram > g[data-step="'+ activeStep +'"], .step-content[data-step="'+ activeStep +'"], .actor-icons > div[data-step="'+ activeStep +'"], .image-area img.'+ activeStep).addClass('active');
        $('.step-content .content-area .content, .step-content .links a').hide();

        $('.actor-icons').fadeOut();
        $('.actor-icons[data-step="'+ activeStep +'"]').delay(500).fadeIn('fast');

        updateActor();

    }
    
    const updateActor = () => {
        console.log(activeActor, activeStep);
        $('div[data-step="' + activeStep + '"] .icon').removeClass('active');
        $('div[data-step="' + activeStep + '"] .icon[data-actor="' + activeActor + '"]').addClass('active');

        $('.step-content[data-step="' + activeStep + '"] .content-area .content').fadeOut();
        $('.step-content[data-step="' + activeStep + '"] .content-area .content[data-actor="' + activeActor + '"]').delay(500).fadeIn('fast');

        $('.step-content[data-step="' + activeStep + '"] .links a').fadeOut();

        // for next links
        if(activeActor === 'undefined') {
            $('.step-content[data-step="' + activeStep + '"] .links a').eq(0).delay(500).fadeIn('fast');
        } else {
            $('.step-content[data-step="' + activeStep + '"] .links a').eq(activeActor + 1).delay(500).fadeIn('fast');
        }
    }

    updateStep(); 
});